class StripeLinkDataModel {
  constructor(data) {
    this.url = data.url;
    this.expiredAt = data.expiredAt;
  }
}

export default StripeLinkDataModel;
